import React, { useState } from 'react';
import { Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useAppSelector } from 'hooks/useAppSelector';
import DraftsPanel from 'components/DraftsPanel';

const DraftsBanner = () => {
    const drafts = useAppSelector((state) => state.spotDrafts.drafts);
    const jwt = useAppSelector((state) => state.auth.jwt);
    const [panelOpen, setPanelOpen] = useState(false);

    if (!jwt || drafts.length === 0) return null;

    return (
        <>
            <Chip
                label={`${drafts.length} draft spot${drafts.length > 1 ? 's' : ''}`}
                icon={<EditIcon />}
                onClick={() => setPanelOpen(true)}
                sx={{
                    'position': 'absolute',
                    'bottom': 24,
                    'left': '50%',
                    'transform': 'translateX(-50%)',
                    'zIndex': 10,
                    'cursor': 'pointer',
                    'fontWeight': 600,
                    'backgroundColor': 'secondary.main',
                    'color': 'secondary.contrastText',
                    '& .MuiChip-icon': { color: 'secondary.contrastText' },
                    '&:hover': { backgroundColor: 'secondary.dark' },
                }}
            />
            <DraftsPanel open={panelOpen} onClose={() => setPanelOpen(false)} />
        </>
    );
};

export default DraftsBanner;
